import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import IconError from './IconError.jsx';
import { flattenObject } from '../../../util/helpers';

class ErrorPanel extends Component {

  render() {
    const {
      className,
      errors
    } = this.props;

    const flatErrors = flattenObject(errors);

    const classes = 'x-error-panel';

    return (
      <div className={classNames(className, classes)}>
        {Object.keys(flatErrors).map((error, index) => {
          return (
            <p className="x-error-message x-body1" key={index}>
              <IconError className="x-error-icon" size="30"/>
              <span className="x-error-text">{flatErrors[error]}</span>
            </p>
          );
        })}
      </div>
    );
  }
}

ErrorPanel.propTypes = {
    className: PropTypes.string,
    errors: PropTypes.object
};

export default ErrorPanel;



/** WEBPACK FOOTER **
 ** ./client/components/Common/Error/ErrorPanel.jsx
 **/